import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import ReduxThunk from 'redux-thunk';

// @TODO: Reenable this some day
// import { sentryMiddleware } from '../utils/logging/sentry';

import { rootEpic } from './epics/root.epic';
import { biLoggerMiddleware } from './middlewares';
import { callApiMiddleware } from './middlewares/call-api/call-api';
import { googleAnalyticsMiddleware } from './middlewares/google-analytics/google-analytics';
import { jobsMiddleware } from './middlewares/jobs/jobs.middleware';
import { notificationMiddleware } from './middlewares/notifications/notifications';
import { requestsCounter } from './middlewares/requests-counter';
import { rootReducer } from './reducers';
import { StoreState } from './reducers/store.types';

// TODO: fix organization.organizations, project.projects, application.applications
export function configureStore() {
  const epicMiddleware = createEpicMiddleware();

  const store = createStore<StoreState, any, any, any>(
    rootReducer,
    // redux-logger should be the last middleware in the chain
    // read more: https://github.com/evgenyrodionov/redux-logger#usage
    composeWithDevTools(
      applyMiddleware(
        googleAnalyticsMiddleware,
        // @TODO: re-enable this some day
        // sentryMiddleware,
        requestsCounter,
        callApiMiddleware,
        jobsMiddleware,
        biLoggerMiddleware,
        notificationMiddleware,
        epicMiddleware,
        ReduxThunk,
      ),
    ),
  );

  epicMiddleware.run(rootEpic);

  // Enable webpack hot module replacement for reducers
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(require('./reducers').rootReducer);
    });
  }

  /*
  if (module.hot) {
    module.hot.accept('./epics/root.epic', () => {
      epicMiddleware.replaceEpic(require('./epics/root.epic').rootEpic);
    });
  }
   */

  return store;
}
